import React, {Fragment} from 'react'

const SecondSection = ({data}) => {

  return (
    <Fragment>
         <hr />
         <div className="row pt-50 pb-70 wow fadeInUp delay-0-2s">
            <div className="col-lg-4">
              <h3 className="title mb-30"> {data.PFS_Heading} </h3>
            </div>
            <div className="col-lg-8">
              <div className="big-letter text">
              {data.PFS_Paragraph}
              </div>
            </div>
          </div>
    </Fragment>
  )
}

export default SecondSection